import React, { Component } from 'react';
import { connect } from 'react-redux';
import { do_action } from '../../actions';
import {convertPrice, convertPriceNumber} from '../../utils/convert'
import Spinner from 'react-spinkit'
import {Link} from 'react-router-dom'
import Pagination from '../Common/Pagination';

class Projects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            prices: [],
            total: 0,
            number_page: 1,
            page: 1,
            limit: 10,
            loading: true
        }
    }

    getProjects = (vendor, page) => {
        let {limit} = this.state;
        let urlQuery = 'vendor_get_projects'
        if (vendor.type == 'designer')
            urlQuery = 'designer_get_projects'

        if (vendor.type == 'pm')
            urlQuery = 'pm_get_projects'

        this.setState({
            loading: true
        })

        do_action(urlQuery, { vendor: vendor._id, page, limit })
        .then(data => {

            this.setState({
                loading: false
            })

            if (data.signal) {
                let {listQuotes, listPrice, total, number_page} = data.data;
                this.setState({
                    projects: listQuotes,
                    prices: listPrice,
                    page,
                    total,
                    number_page
                })
            }
        }).catch(err => {
            this.setState({
                loading: false
            })
        });
    }

    componentWillMount = () => {
        if (this.props.vendor._id)
            this.getProjects(this.props.vendor, 1)
    }

    componentWillReceiveProps = (nextProps) => {
        this.getProjects(nextProps.vendor, 1)
    }

    clickPage(page) {
        let {vendor} = this.props;
        this.getProjects(vendor, page);
    }

    renderProject = () => {

        let {projects, loading} = this.state;

        if (loading) {
            return (
                <div className="row text-center bg-white">
                    <Spinner name="line-scale-pulse-out-rapid" color="steelblue"/>
                </div>
            )
        }

        if (!loading && !projects.length) {
            return (
                <div className="row text-center bg-white">
                    <h4>You don't have any live project</h4>
                </div>
            )
        }

        let result = projects.map((item, index) => <tr key={index}>
            <td className="w-30"><Link to={`/quotes/detail/${item.quotes._id}`} className="text-black">#{item.quotes._id}</Link></td>
            <td className="w-25">{item.quotes.customer ? `${item.quotes.customer.first_name} ${item.quotes.customer.last_name}` : ''}</td>
            <td className="text-primary-kt fontSemiBold w-20">{`$${convertPriceNumber(this.state.prices[index])}`}</td>
            <td className="text-center w-25">
                <Link to={`/quotes/detail/${item.quotes._id}`} className="action-details mr-5">Detail</Link>
                <Link to={`/projects/payment/${item.quotes._id}`} className="action-payment">Payment terms</Link>
            </td>

        </tr>)

        return (
            <div className="form-group table-responsive table-kt">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="w-30">
                                Project
                            </th>
                            <th className="w-25">
                                Client
                            </th>
                            <th className="w-20">
                                Amount
                            </th>
                            <th className="text-center w-25">
                                &nbsp;
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {result}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {

        let {total, number_page, page} = this.state;

        return (
            <div className="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 maindb">
                <div className="form-group clearfix">
                    <div className="pull-left">
                        <h3 className="marginT0">Live Projects</h3>
                    </div>
                </div>
                
                {this.renderProject()}

                <Pagination page={page} number_page={number_page} clickPage={this.clickPage.bind(this)}/>

            </div>
        )
    }
}

function mapStateToProps(state) {
    const { vendor } = state;
    return {
        vendor
    }
}

export default connect(mapStateToProps)(Projects);